import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col h-28 w-full items-center justify-center"
}
const _hoisted_2 = ["accept"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "49",
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M28 8.01709H12C10.9391 8.01709 9.92172 8.43852 9.17157 9.18866C8.42143 9.93881 8 10.9562 8 12.0171V32.0171M8 32.0171V36.0171C8 37.078 8.42143 38.0954 9.17157 38.8455C9.92172 39.5957 10.9391 40.0171 12 40.0171H36C37.0609 40.0171 38.0783 39.5957 38.8284 38.8455C39.5786 38.0954 40 37.078 40 36.0171V28.0171M8 32.0171L17.172 22.8451C17.9221 22.0952 18.9393 21.6739 20 21.6739C21.0607 21.6739 22.0779 22.0952 22.828 22.8451L28 28.0171M40 20.0171V28.0171M40 28.0171L36.828 24.8451C36.0779 24.0952 35.0607 23.6739 34 23.6739C32.9393 23.6739 31.9221 24.0952 31.172 24.8451L28 28.0171M28 28.0171L32 32.0171M36 8.01709H44M40 4.01709V12.0171M28 16.0171H28.02",
      stroke: "#67767F",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_4 = { class: "flex text-sm font-medium text-dark-2" }
const _hoisted_5 = { class: "flex text-xs text-dark-2" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col w-full h-28 items-center justify-center"
}
const _hoisted_7 = {
  key: 2,
  class: "text-sm text-dark-2"
}
const _hoisted_8 = ["alt", "src"]
const _hoisted_9 = { class: "flex align-middle" }
const _hoisted_10 = { class: "my-auto" }
const _hoisted_11 = {
  key: 3,
  class: "flex flex-col w-full items-center pt-3"
}
const _hoisted_12 = { class: "list-disc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_app_alert = _resolveComponent("app-alert")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-156 border-2 rounded-md border-dashed py-8 px-5", [_ctx.dropAreaActive ? 'border-blue-500' : 'border-light-3']]),
    onDragenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragEnter && _ctx.onDragEnter(...args))),
    onDragover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
    onDragleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
    onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
  }, [
    (!_ctx.files.length && !_ctx.$slots.dropArea)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("input", {
            ref: "fileInput",
            type: "file",
            class: "hidden",
            accept: _ctx.accept,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args)))
          }, null, 40, _hoisted_2),
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", {
              class: "text-blue-500 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.$refs.fileInput.click && this.$refs.fileInput.click(...args)))
            }, _toDisplayString(_ctx.$t("components.appUpload.uploadFile")), 1),
            _createTextVNode("  " + _toDisplayString(_ctx.$t("components.appUpload.dropFile")), 1)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("components.appUpload.limitations")), 1)
        ]))
      : (_ctx.$slots.dropArea)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "dropArea")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col w-full h-28 items-center justify-center",
                key: file.name + file.type + file.size
              }, [
                (_ctx.isImage(file))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      role: "presentation",
                      alt: file.name,
                      src: _ctx.getObjectUrl(file),
                      class: "max-h-24 w-auto"
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_app_button, {
                    "button-style": "transparentUnderline",
                    onClick: ($event: any) => (_ctx.remove(index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("general.cancel")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_progress_bar, {
                      mode: "indeterminate",
                      class: "w-10 h-2"
                    })
                  ])
                ])
              ]))
            }), 128))
          ])),
    (_ctx.messages.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_app_alert, {
            type: "danger",
            "dismiss-button": true,
            onDismiss: _ctx.onMessageClose
          }, {
            header: _withCtx(() => [
              _createTextVNode("Error")
            ]),
            content: _withCtx(() => [
              _createElementVNode("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                  return (_openBlock(), _createElementBlock("li", { key: message }, _toDisplayString(message), 1))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["onDismiss"])
        ]))
      : _createCommentVNode("", true)
  ], 34))
}